import { useTranslation } from 'react-i18next';
import React from "react";
import { Form, DatePicker } from "antd";

export const __FormDatePicker = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            hidden={props.hidden}
        >
            <DatePicker
                className="width-100"
                format={props?.format ?? "YYYY-MM-DD HH:mm:ss"}
                showTime={props.showTime}
                disabledTime={props.disabledDateTime}
                disabled={props.disable}
                allowClear
                showNow={true}
            />
        </Form.Item>
    )
}